export const TYPE_ERROR = 'error';
export const TYPE_WARNING = 'warning';
export const TYPE_SUCCESS = 'success';
export const TYPE_INFO = 'info';

export const ALL_TYPES = [TYPE_ERROR, TYPE_WARNING, TYPE_SUCCESS, TYPE_INFO];
